import { useSyncExternalStore } from "react";
import { currentPath, matchRoute, subscribeToPath, type RouteId } from "./router.js";

/** Current pathname; re-renders on navigation and on browser back/forward. */
export function usePath(): string {
  return useSyncExternalStore(subscribeToPath, currentPath, currentPath);
}

/** Route id for the current path, or null when nothing matches. */
export function useRoute(): RouteId | null {
  return matchRoute(usePath());
}
